import React, { useEffect } from "react";
import Chrome from "@uiw/react-color-chrome";

import { Props } from "./types";
import styles from "./styles.scss";

function ColorPicker(props: Props) {
  const submit = (event: any) => {
    event.key === "Enter" && props.submit && props.submit();
  };

  useEffect(() => {
    window.addEventListener("keydown", submit);
    return () => {
      window.removeEventListener("keydown", submit);
    };
  }, []);

  return (
    <div
      className={styles.colorPicker}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Chrome
        color={props.color}
        className={styles.colorPicker}
        onChange={(color) => props.pick(color.hex)}
      />
    </div>
  );
}

export { ColorPicker };
